var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperPlane(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 97,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 36.898L125 .172 34.204 49.901 0 36.898z",
    fill: "#A36FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125 .172L34.205 49.901l14.58 31.069L125 .172z",
    fill: "#8C4BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125 .172l-72.378 56.24 29.096 39.95L125 .172z",
    fill: "#A36FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.785 80.97l3.837-24.557 8.42 11.555L48.784 80.97z",
    fill: "#7E43E6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default "/_next/static/images/9666cf14cbf0498c2800a0f5d9f50071.svg";
export { ForwardRef as ReactComponent };